import React, { useState } from "react"
import { withRouter } from "react-router"
import { getImportTypeDefinition } from "utils/dataImportType"
import { CustomServerSideReactTableNew } from "components/utility"
import { Row, Col, Label, Input, FormGroup } from "reactstrap"
import { GET_PRODUCTS, DELETE_PRODUCT, SUM_PRODUCTS } from "../../gql"
import { GET_TABLE_FIELDS } from "../../../order-query/gql"
// import { useQuery, useMutation } from "@apollo/react-hooks"
// import { Spinner } from "components/spinner"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const ProductList = (props) => {
  const [queryParam, setQueryParam] = useState({})

  const columnDefs = [
    { title: "產品名稱", name: "name", type: "input" },
    { title: "產品編號", name: "productNumber", type: "input" },
    { title: "類別名稱", name: "categoryName", type: "input" },
    { title: "子類別名稱", name: "subcategoryName", type: "input" }
  ]

  const fieldsDefinitions = () => {
    return [
      {
        id: "name",
        Header: "名稱",
        style: columStyle,
        accessor: "name",
        width: 200
      },
      {
        id: "productNumber",
        Header: "編號",
        style: columStyle,
        accessor: "productNumber",
        width: 200
      },
      {
        id: "description",
        Header: "描述",
        style: columStyle,
        width: 200,
        accessor: "description"
      },
      {
        id: "category",
        Header: "類別",
        style: columStyle,
        accessor: (data) => data.category?.name,
        width: 200
      },
      {
        id: "subcategory",
        Header: "子類別",
        style: columStyle,
        accessor: (data) => data.subcategory?.name,
        width: 200
      },
      {
        id: "isEnable",
        Header: "是否啟用",
        style: columStyle,
        width: 100,
        accessor: (data) => (data.isEnable ? "是" : "否")
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_PRODUCTS}
      sumTotalQueryObjectGql={SUM_PRODUCTS}
      deleteObjectGql={DELETE_PRODUCT}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectRoute={props.match.url}
      // hasSettingButton={false}
      objectName="產品"
      hasEditButton={true}
      hasUploadButton={true}
      hasCreateButton={true}
      fieldsDef={fieldsDefinitions()}
      uploadSettings={getImportTypeDefinition("PRODUCT")}
    />
    // {/* <CustomServerSideProductReactTable
    //   queryObjectGql={GET_PRODUCTS}
    //   sumTotalQueryObjectGql={SUM_PRODUCTS}
    //   objectRoute={props.match.url}
    //   hasDeleteButton={false}
    //   fieldsDef={fieldsDefinitions()}
    //   // data={data?.products?.data}
    //   // refetchCallback={refetch}
    //   // deleteCallback={deleteData}
    //   // totalPage={data.totalPage}
    // /> */}
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }
export default withRouter(ProductList)
